import { AppLayout } from "../../components/layout/Header";
import AuditLogView from "../../components/messaging/AuditLogView";

export default function AgentAudit() {
  return (
    <AppLayout variant="agent">
      <AuditLogView title="Assigned-file log" />
    </AppLayout>
  );
}
